const LatestOrdersList = {
    orderList : [
        {orderNumber : "W2***12", date : "10-13", amount : "1400", progress : 100},
        {orderNumber : "W2***23", date : "10-17", amount : "2900", progress : 100},
        {orderNumber : "W2***36", date : "10-22", amount : "3600", progress : 70},
        {orderNumber : "W2***42", date : "10-23", amount : "4300", progress : 80},
        {orderNumber : "W2***57", date : "10-24", amount : "5200", progress : 50},
        {orderNumber : "W2***67", date : "10-25", amount : "6100", progress : 45},
        {orderNumber : "W2***79", date : "01-10", amount : "7600", progress : 100},
        {orderNumber : "W2***88", date : "06-20", amount : "8400", progress : 90},
        {orderNumber : "W2***90", date : "03-30", amount : "9800", progress : 11},
        {orderNumber : "W2***05", date : "01-20", amount : "1400", progress : 27},
        {orderNumber : "W2***17", date : "05-23", amount : "2600", progress : 10},
        {orderNumber : "W2***25", date : "03-22", amount : "3100", progress : 27},
        {orderNumber : "W2***35", date : "09-20", amount : "4200", progress : 31},
        {orderNumber : "W2***44", date : "05-20", amount : "5300", progress : 42},
        {orderNumber : "W2***57", date : "08-20", amount : "6400", progress : 53},
        {orderNumber : "W2***67", date : "03-05", amount : "7800", progress : 64},
        {orderNumber : "W2***72", date : "05-06", amount : "8900", progress : 75},
        {orderNumber : "W2***81", date : "11-20", amount : "9100", progress : 100},
    ]
};




export default LatestOrdersList;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/PCBService/LatestOrders/LatestOrdersList.js